import { useEffect, useState } from "react";
import { PencilLine } from "lucide-react";

function labelForItem(item) {
  const kode = item?.kode_barang || "-";
  const name = item?.nama_barang ? ` - ${item.nama_barang}` : "";
  return `${kode}${name}`;
}

export default function RequestEditModal({ item, valueRef }) {
  const [qty, setQty] = useState(Math.max(1, Math.trunc(Number(item?.qty) || 1)));
  const [keterangan, setKeterangan] = useState(String(item?.keterangan || ""));
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!valueRef) return;
    valueRef.current = {
      qty,
      keterangan,
      reason,
    };
  }, [qty, keterangan, reason, valueRef]);

  return (
    <div className="space-y-3">
      <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 text-sm text-slate-700">
        <div className="flex items-start gap-3">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700">
            <PencilLine className="h-4 w-4" aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <div className="font-semibold text-slate-900">Request perubahan histori</div>
            <div className="mt-1 break-words">
              Produk: <span className="font-mono">{labelForItem(item)}</span>
            </div>
            <div>
              Qty saat ini: <span className="font-semibold text-slate-900">{item?.qty ?? "-"}</span>
            </div>
          </div>
        </div>
        <div className="mt-1 text-xs text-slate-500">Perubahan histori membutuhkan persetujuan admin.</div>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div>
          <label className="field-label">Qty baru</label>
          <input
            type="number"
            value={qty}
            onChange={(e) => {
              if (e.target.value === "") {
                setQty("");
                return;
              }
              const v = Math.trunc(Number(e.target.value));
              if (Number.isFinite(v) && v > 0) {
                setQty(v);
              }
            }}
            className="input"
            autoFocus
          />
        </div>

        <div>
          <label className="field-label">Keterangan baru</label>
          <input
            value={keterangan}
            onChange={(e) => setKeterangan(e.target.value)}
            className="input"
            placeholder="Opsional"
          />
        </div>
      </div>

      <div>
        <label className="field-label">Alasan perubahan</label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="input min-h-24"
          placeholder="Contoh: salah input qty, koreksi keterangan, dll."
        />
        <div className="field-help">Wajib diisi. Request akan masuk ke approval admin.</div>
      </div>
    </div>
  );
}
